import React, { useState, useEffect } from 'react';

const InstagramPage = () => {
  const [posts, setPosts] = useState([]);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [visibleCount, setVisibleCount] = useState(10); 

  const token = "IGAARPZBcpfwhBBZAFlJMWRaZAF9PRldJU1c3aTBBQmFPVFhJbUpXSFozcGRfX1dHQjM4dmd6R2VHMVNLVGhoNXotTzlidF9PTFJETkcxbDdvNWFnTkI1RUtvTFd0TGt6WU9IVGsyNmktejhWV3VscUVBOTJkdGhtYS16MzgxMjlkbwZDZD";

  useEffect(() => {
    const fetchInstagramData = async () => {
      try {
        const profileRes = await fetch(`https://graph.instagram.com/me?fields=username,account_type&access_token=${token}`);
        const profileData = await profileRes.json();
        setProfile(profileData);

        const mediaRes = await fetch(`https://graph.instagram.com/me/media?fields=id,caption,media_url,permalink,media_type,thumbnail_url&access_token=${token}`);
        const mediaData = await mediaRes.json();
        setPosts(mediaData.data || []);
        
        setLoading(false);
      } catch (error) {
        console.error("Erro ao carregar dados do Instagram:", error);
        setLoading(false);
      }
    };

    if (token) fetchInstagramData();
  }, [token]);

  if (loading) return <div className="py-20 text-center text-[#A8A29A] bg-[#FAF9F6]">A carregar o portefólio...</div>;

  return (
    <main className="min-h-screen bg-[#FAF9F6] pt-24 pb-16">
      <div className="max-w-6xl mx-auto px-4">
        
        {/* Cabeçalho do Perfil com efeito Hover */}
        <div className="flex flex-col items-center mb-12 text-center">
          <a 
            href={`https://instagram.com/${profile?.username || 'louswaystudio'}`}
            target="_blank"
            rel="noreferrer"
            className="relative w-24 h-24 rounded-full overflow-hidden mb-4 border border-[#E6E2DA] group cursor-pointer"
          >
            {/* Foto de Perfil */}
            <img 
              src="https://res.cloudinary.com/dwpnw1fgc/image/upload/v1772301177/440700348_967697811693749_5842566526176456774_n_bb02iy.jpg" 
              alt="Profile" 
              className="w-full h-full object-cover transition-opacity duration-300 group-hover:opacity-40" 
            />
            
            {/* Ícone do Instagram no Hover */}
            <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-black/20">
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="white" viewBox="0 0 256 256">
                <path d="M128,80a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,80Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,160ZM176,24H80A56.06,56.06,0,0,0,24,80v96a56.06,56.06,0,0,0,56,56h96a56.06,56.06,0,0,0,56-56V80A56.06,56.06,0,0,0,176,24Zm40,152a40,40,0,0,1-40,40H80a40,40,0,0,1-40-40V80A40,40,0,0,1,80,40h96a40,40,0,0,1,40,40ZM192,72a12,12,0,1,1-12-12A12,12,0,0,1,192,72Z"></path>
              </svg>
            </div>
          </a>

          <h1 className="text-xl font-medium text-[#1A1815] mb-2">
            @{profile?.username || 'louswaystudio'}
          </h1>
          <p className="max-w-2xl text-sm text-[#6B6661] leading-relaxed">
            Especialista em Microblading e Estética Avançada. <br />
            Transformando olhares com naturalidade e confiança em Torres Vedras. ✨
          </p>
        </div>

        {/* Grelha de Imagens */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-1.5">
          {posts.slice(0, visibleCount).map((post) => (
            <a 
              key={post.id} 
              href={post.permalink} 
              target="_blank" 
              rel="noreferrer" 
              className="relative aspect-square overflow-hidden group"
            >
              <img 
                src={post.media_type === 'VIDEO' ? post.thumbnail_url : post.media_url} 
                alt={post.caption || "Post Instagram"} 
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              {post.media_type === 'CAROUSEL_ALBUM' && (
                <div className="absolute top-2 right-2 text-white drop-shadow-md">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 256 256"><path d="M216,40H88A16,16,0,0,0,72,56V184a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,144H88V56H216V184ZM184,216a8,8,0,0,1-8,8H40a16,16,0,0,1-16-16V80a8,8,0,0,1,16,0V208H176A8,8,0,0,1,184,216Z"></path></svg>
                </div>
              )}
            </a>
          ))}
        </div>

        {/* Botões de Ação */}
        <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
          {visibleCount < posts.length && (
            <button 
              onClick={() => setVisibleCount(prev => prev + 10)}
              className="px-8 py-2.5 bg-[#33302C] text-white text-sm font-medium rounded hover:bg-[#1A1815] transition-colors"
            >
              Load More
            </button>
          )}
          <a 
            href={`https://instagram.com/${profile?.username || 'louswaystudio'}`}
            target="_blank" 
            rel="noreferrer"
            className="flex items-center gap-2 px-8 py-2.5 bg-[#4A90E2] text-white text-sm font-medium rounded hover:bg-[#357ABD] transition-colors"
          >
            <span>📸</span> Follow on Instagram
          </a>
        </div>
      </div>
    </main>
  );
};

export default InstagramPage;